import OptionsPanelField from './OptionsPanelField';

/** All select filters use multi-select checkboxes. */
const SelectField = (props) => <OptionsPanelField {...props} multiSelect />;

export default SelectField;
